import BaseLine from '../line-base';

export default class CustomLine extends BaseLine {
}
